import { ProjectTeamInterface } from "../project/project-team-interface";
import { ReportDescriptionInterface } from "../report/report-description-interface";
import { ReportInterface } from "../report/report-interface";
import { UserDecisionInterface } from "./user-decision-interface";
import { UserInterface } from "./user-interface";

export interface UserStateInterface {
  user: UserInterface | null;
  data?: any;
  response?: any;
  // Percentage of the current direct-to-Wasabi upload, or null when idle.
  uploadProgress?: number | null;
  // Percentage of a folder or project archive being bundled in the browser,
  // or null when idle.
  archiveProgress?: number | null;
  // Result of an IFC -> fragments conversion, waiting to be turned into an
  // upload. Deliberately separate from `data`, which CoreHandler treats as a
  // server operation and dispatches on.
  modelConversion?: any;
  modelViewerData?: any;
  openUrl?: any;
  openModel?: any;
  openPdf?: any;
  openReport?: ReportInterface | null;
  openReportDescription?: ReportDescriptionInterface | null;
  projectTeam?: ProjectTeamInterface | null | undefined;
  decision?: UserDecisionInterface | null;
  type: "UserStateInterface";
}

export const initialState: UserStateInterface = {
  user: null,
  type: "UserStateInterface",
};
